e360.controller('ImporterErrorController', [
    '$scope',
    '$uibModalInstance',
    'header',

    function ($scope, $uibModalInstance, header) {
        $scope.header = header;

        $scope.close = function () {
            $uibModalInstance.dismiss('close');
        };
    }
]);
